export default __webpack_public_path__ + "static/3-754f8caed0056d5f613c12591ac147b3.jpg";